export default __webpack_public_path__ + "static/wood-93ffd6b1d9186015007b09c5b62ae48d.png";